export const STORAGE_KEY = 'voip-monitor-alerts';

export const ALERTS_THRESHOLDS = {
  PACKET_LOSS_THRESHOLD: 3, // More than 3% packet loss is problematic
  JITTER_THRESHOLD: 30, // More than 30ms jitter is problematic
  LATENCY_THRESHOLD: 150, // More than 150ms round-trip time is problematic
  MOS_THRESHOLD: 3.5, // MOS score below 3.5 indicates poor quality
};